<script lang="ts" setup>
  import type { CSSProperties } from 'vue';
  import type { Space } from '../space.ts';

  withDefaults(
    defineProps<{
      as?: string;
      space?: Space;
      justify?: CSSProperties['justifyContent'];
      align?: CSSProperties['alignItems'];
    }>(),
    { as: 'div', space: 'm', justify: 'flex-start', align: 'center' },
  );
</script>

<template>
  <component :is="as" class="cluster" :data-space="space" :style="{ justifyContent: justify, alignItems: align }">
    <slot />
  </component>
</template>

<style scoped>
  .cluster {
    display: flex;
    flex-wrap: wrap;
    gap: var(--cluster-space);
  }

  .cluster[data-space='xs'] {
    --cluster-space: var(--space-xs);
  }

  .cluster[data-space='s'] {
    --cluster-space: var(--space-s);
  }

  .cluster[data-space='m'] {
    --cluster-space: var(--space-m);
  }

  .cluster[data-space='l'] {
    --cluster-space: var(--space-l);
  }

  .cluster[data-space='xl'] {
    --cluster-space: var(--space-xl);
  }
</style>
